import { render, staticRenderFns } from "./TanchuangFrame.vue?vue&type=template&id=3a77106d&scoped=true"
import script from "./TanchuangFrame.vue?vue&type=script&lang=js"
export * from "./TanchuangFrame.vue?vue&type=script&lang=js"
import style0 from "./TanchuangFrame.vue?vue&type=style&index=0&id=3a77106d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a77106d",
  null
  
)

export default component.exports